import { GET_INTERNAL_ASSISTANCE_REPORT_BY_FILTER } from '@/graphql/reports/internalAssistance'

// models
import { ReportInternalAssistance, FilterReportInternalAssistance } from '@/models/reports/ReportInternalAssistance'

// apollo
import { apolloClient } from '@/apollo'

class ReportInternalAssistanceService {
  async getReportInternalAssistance (input: FilterReportInternalAssistance): Promise<ReportInternalAssistance> {
    const result = await apolloClient.query({
        query: GET_INTERNAL_ASSISTANCE_REPORT_BY_FILTER,
        variables: {
          input
        }
    })
    return result.data.getReportInternalAssistance
  }
}

export default new ReportInternalAssistanceService()
